import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const STORAGE_KEY = "kyro_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, plan) => {
    setItems((prev) => {
      const key = `${product.id}::${plan.label}`;
      const exists = prev.find((i) => i.key === key);
      if (exists) return prev;
      return [...prev, {
        key,
        product_id: product.id,
        slug: product.slug,
        name: product.name,
        image_url: product.image_url,
        plan_label: plan.label,
        duration_months: plan.duration_months,
        price: plan.price,
      }];
    });
    setOpen(true);
  };

  const remove = (key) => setItems((p) => p.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.price, 0);
    return { subtotal, total: subtotal, count: items.length };
  }, [items]);

  return (
    <CartCtx.Provider value={{ items, add, remove, clear, open, setOpen, ...totals }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
